var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManufacturerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.302 4.228a.688.688 0 0 0-.688 0L13.75 7.136V4.812a.689.689 0 0 0-.997-.611L6.875 7.136V2.062a.688.688 0 0 0-.688-.687H2.063a.688.688 0 0 0-.687.688V19.25h19.25V4.812a.688.688 0 0 0-.323-.584zm-5.177 13.647h-2.75v-4.813h2.75v4.813zm4.125 0H16.5v-5.5a.687.687 0 0 0-.688-.688h-4.124a.687.687 0 0 0-.688.688v5.5H2.75V2.75H5.5v6.614l6.875-3.438v3.438l6.875-3.438v11.949z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturerIcon);
export default __webpack_public_path__ + "static/media/manufacturerIcon.329bd378b3d0932a1cf44b438dce9411.svg";
export { ForwardRef as ReactComponent };